import * as Sentry from '@sentry/vue'

export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter()
  const runtimeConfig = useRuntimeConfig()

  const dns = runtimeConfig.public?.sentryURL

  if (!dns) {
    console.warn('Missing Sentry dns')
    return
  }
  Sentry.init({
    app: nuxtApp.vueApp,
    dsn: dns,
    integrations: [Sentry.browserTracingIntegration({ router })],
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of the transactions
  })
})
